import { CONSTANTS } from "./dictionary";

/**
 * Convierte un peso en una magnitud a otra magnitud
 * @param {{ wheight: number, toMagnitud: string }} options
 * @param {number} options.wheight Peso a convertir
 * @param {string} options.toMagnitud Magnitud a la que se va a convertir. Valores posibles: 'lbs' o 'tns'
 * @returns {number} Peso convertido
 */
const _handleWeightConversion = ({ wheight, toMagnitud }) => {
  const lbsToTns = 0.00045359237;
  const tnsToLbs = 2204.6226218488;
  const conversionFactor =
    toMagnitud === CONSTANTS.MAGNITUDES.TONELADAS ? lbsToTns : tnsToLbs;
  return parseFloat(wheight * conversionFactor);
};

/**
 * Converts a weight value from pounds (lbs) to tons (toneladas).
 *
 * @param {number} wheight - The weight value in pounds to be converted.
 * @returns {number} The converted weight value in tons.
 */
export const lbsToTns = (wheight) =>
  _handleWeightConversion({
    wheight,
    toMagnitud: CONSTANTS.MAGNITUDES.TONELADAS,
  });

/**
 * Converts a weight value from tons (tns) to pounds (lbs).
 *
 * @param {number} wheight - The weight value in tons to be converted.
 * @returns {number} The converted weight value in pounds.
 */
export const tnsToLbs = (wheight) =>
  _handleWeightConversion({
    wheight,
    toMagnitud: CONSTANTS.MAGNITUDES.LIBRAS,
  });
